<template>
  <div class="page-login">
    <weui-group>
      <weui-input label="手机号码" v-model="phone" type="tel" placeholder="填写手机号码" />
      <weui-input label="图形验证码" v-model="captcha" placeholder="输入图形验证码" :show-vcode="true">
        <img slot="image" class="weui-vcode-img" :src="captchaImg" @click="fetchCaptcha">
      </weui-input>
      <weui-input label="验证码" v-model="sms_code" type="number" placeholder="输入验证码" :show-vcode="true">
        <vcode-button slot="button" :phone="phone" :captcha="captcha" />
      </weui-input>
    </weui-group>
    <weui-button-area>
      <weui-button class="login-btn" type="primary" @click="login">下一步</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { WeuiGroup, WeuiInput, WeuiButton, WeuiButtonArea } from '@/components/weui';
import VcodeButton from '@/components/auth/VcodeButton';

import { FETCH_CAPTCHA, LOGIN } from '@/store/auth/types';
import { WECHAT_BIND_COACH } from '@/store/coach/types';
import { ROUTE_LOGIN_GUIDE, ROUTE_WECHAT_AUTHORIZE } from '@/router/names';
import auth from '@/auth';

const { mapState, mapActions } = createNamespacedHelpers('auth');
const { mapState: mapWechatState } = createNamespacedHelpers('wechat');
const { mapActions: mapCoachActions } = createNamespacedHelpers('coach');

export default {
    data() {
        return {
            phone: '',
            captcha: '',
            sms_code: '',
        };
    },
    computed: {
        ...mapState([
            'captchaImg',
        ]),
        ...mapWechatState([
            'openid',
        ]),
    },
    created() {
        if (!this.openid) {
            this.$router.replace({
                name: ROUTE_WECHAT_AUTHORIZE,
            });
        }
    },
    mounted() {
        if (auth.loggedIn()) {
            this.afterLogin();
            return;
        }
        this.fetchCaptcha();
    },
    methods: {
        ...mapActions({
            fetchCaptcha: FETCH_CAPTCHA,
            apiLogin: LOGIN,
        }),
        ...mapCoachActions({
            wechatBind: WECHAT_BIND_COACH,
        }),
        async login() {
            await this.apiLogin({
                phone: this.phone,
                smsCode: this.sms_code,
            });
            await this.afterLogin();
        },
        async afterLogin() {
            // 微信已登录，绑定微信
            await this.wechatBind();
            this.$router.replace({
                name: ROUTE_LOGIN_GUIDE,
            });
        },
    },
    components: {
        WeuiGroup,
        WeuiInput,
        WeuiButton,
        WeuiButtonArea,
        VcodeButton,
    },
};
</script>

<style scoped>
.weui-vcode-img {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/containers/login/Phone.vue